import { Storage } from '@ionic/storage';
import { GDStorageInterface } from '../../model/gd-storage';
import { SFGOAuthService } from '../../providers/sfgoauth.service/sfgoauth.service';
import { Injectable, Inject } from '@angular/core';
import { LoopBackAuth } from '../sdk';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import moment from "moment";
@Injectable()
export class NestAuthProvider {
  private _accessToken: string;
  public setAuth = new Subject();
  private SFGoStorage: GDStorageInterface;

  constructor(
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    public http: HttpClient,
    private sfgoAuthService: SFGOAuthService,
    private storage: Storage
  ) {
    this._accessToken = this.auth.getAccessTokenId();
  }

  public isAuthenticated(): boolean {
    return this._accessToken != null;
  }

  public getAccessToken(): string {
    this._accessToken = this.auth.getAccessTokenId();
    return this._accessToken;
  }

  public login(params): Observable<any> {
    const preLoginData = params.preLoginData;
    const ist: string = preLoginData.IST;
    let goPath = preLoginData.GOPATH + '/api/sunfishes/login';
    const headers = new HttpHeaders({ timeout: '60000' }).append('Content-Type', 'application/json');
    const isWebview = localStorage.getItem('webOpenFromWebview');
    if (isWebview) {
      headers.append("app", "gd8");
    }

    if (preLoginData.hasOwnProperty('GOPATHNEW') && !ist.toLowerCase().includes('-local')) {
      const GOPATHNEW = preLoginData.GOPATHNEW;
      if (GOPATHNEW) {
        goPath = preLoginData.GOPATHNEW + '/auth/login';
      }
      else {
        this.sfgoAuthService.getGDStorage().then((results) => {
          this.SFGoStorage = results;
          delete this.SFGoStorage.storedPrelogin.GOPATHNEW;
          this.storage.set('SFGoStorage', JSON.stringify(this.SFGoStorage));
        });
      }
    }

    return this.http.post(goPath, JSON.stringify(params), { headers });
  }

  public loginShareAccount(params): Observable<any> {
    const preLoginData = params.preLoginData;
    const ist: string = preLoginData.IST;
    let goPath = preLoginData.GOPATH + '/api/sunfishes/login';
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    const isWebview = localStorage.getItem('webOpenFromWebview');
    if (isWebview) {
      headers.append("app", "gd8");
    }

    if (preLoginData.hasOwnProperty('GOPATHNEW') && !ist.toLowerCase().includes('-local')) {
      const GOPATHNEW = preLoginData.GOPATHNEW;
      if (GOPATHNEW) {
        goPath = preLoginData.GOPATHNEW + '/auth/loginShareAccount';
      }
      else {
        this.sfgoAuthService.getGDStorage().then((results) => {
          this.SFGoStorage = results;
          delete this.SFGoStorage.storedPrelogin.GOPATHNEW;
          this.storage.set('SFGoStorage', JSON.stringify(this.SFGoStorage));
        });
      }
    }

    return this.http.post(goPath, JSON.stringify(params), { headers });
  }

  public loginPPA(params): Observable<any> {
    const preLoginData = params.preLoginData;
    const ist: string = preLoginData.IST;
    let goPath = preLoginData.GOPATH + '/api/sunfishes/loginPPA';
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    const isWebview = localStorage.getItem('webOpenFromWebview');
    if (isWebview) {
      headers.append("app", "gd8");
    }

    if (preLoginData.hasOwnProperty('GOPATHNEW') && !ist.toLowerCase().includes('-local')) {
      const GOPATHNEW = preLoginData.GOPATHNEW;
      if (GOPATHNEW) {
        goPath = preLoginData.GOPATHNEW + '/auth/loginPPA';
      }
      else {
        this.sfgoAuthService.getGDStorage().then((results) => {
          this.SFGoStorage = results;
          delete this.SFGoStorage.storedPrelogin.GOPATHNEW;
          this.storage.set('SFGoStorage', JSON.stringify(this.SFGoStorage));
        });
      }
    }

    return this.http.post(goPath, JSON.stringify(params), { headers });
  }

  public loginData(goPath, accessToken): Observable<any> {
    let headers = new HttpHeaders().set('Authorization', accessToken).append('Content-Type', 'application/json').append('cache', 'force-cache');
    const isWebview = localStorage.getItem('webOpenFromWebview');
    if (isWebview) {
      headers = new HttpHeaders().set('Authorization', accessToken).append('Content-Type', 'application/json').append('cache', 'force-cache').append("app", "gd8");
    }
    return this.http.get(goPath + '/auth/loginData?v=' + moment().format('YYYY-MM-DD'), { headers });
  }

  public loginSSO(params): Observable<any> {
    const goPath = localStorage.getItem('$linkSSO');
    const headers = new HttpHeaders({ timeout: '60000' }).append('Content-Type', 'application/json');
    const isWebview = localStorage.getItem('webOpenFromWebview');
    if (isWebview) {
      headers.append("app", "gd8");
    }
    return this.http.post(goPath, JSON.stringify(params), { headers });
  }

  public loginSSOTAM(params): Observable<any> {
    const preLoginData = params.preLoginData;
    const goPath = preLoginData.GOPATHNEW + '/auth/loginTAM';
    const headers = new HttpHeaders({ timeout: '60000' }).append('Content-Type', 'application/json');
    const isWebview = localStorage.getItem('webOpenFromWebview');
    if (isWebview) {
      headers.append("app", "gd8");
    }
    return this.http.post(goPath, JSON.stringify(params), { headers });
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/nest-auth.ts